<div class="no-shops container-v2">
  <h1 class="no-shops-title text-h6-s text-md-h6-l text-lg-h3-m text-xl-h3-l">В вашем городе пока нет магазина</h1>
  <p class="no-shops-subtext text-b3-m-300 text-md-b3-l-300">
    возможность доставки можно уточнить по телефону
    <sd-phone
      class="no-shops-subtext-phone link-black link-underlined link-hover-underlined link-hover-orange"
    ></sd-phone>
  </p>
  <a sdButton routerLink="/catalog" class="no-shops-link text-b3-s-500 text-md-b2-s-500">в каталог</a>
</div>
